import React from "react";

import { Skeleton } from "components";
import { LineDivider } from "components/layout";
import { useLoader } from "hooks";
import { useJarisCheckListQuery } from "queries";

type JarisNotesProps = {
	applicationId: string;
};

const JarisNotes = ({ applicationId }: JarisNotesProps) => {
	const { data: jarisCheckList, isFetching } = useJarisCheckListQuery({
		id: applicationId,
	});

	const Loader = useLoader(isFetching);

	const hasNoData =
		!jarisCheckList ||
		!jarisCheckList.evaluations ||
		jarisCheckList.evaluations.length === 0;

	return (
		<Loader
			skeleton={<Skeleton height="68px" />}
			component={
				hasNoData ? (
					<div>No JARIS evaluation data available.</div>
				) : (
					jarisCheckList.evaluations.map((item, index, array) => (
						<React.Fragment key={item.type + index}>
							<div>
								{item.type}: {item.outcome}
							</div>
							<div>
								{item.reasons?.map((reason, index) => (
									<div key={index}>{reason}</div>
								))}
							</div>
							{index !== array.length - 1 && (
								<LineDivider className="py-1 mt-2" />
							)}
						</React.Fragment>
					))
				)
			}
		/>
	);
};

export default JarisNotes;
